import React from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import Link from "next/link";

import ArrowDownIcon from 'assets/icons/arrow-down.svg';

import classes from './ExploreFaq.module.scss';

const ExploreFaq = () => {
    const accordionStyle = {
        '& p': {
            fontSize: '18px',
            fontWeight: 700
        },
        '&.Mui-expanded': {
            color: '#BB3A90'
        }
    };

    return (
        <>
            <div className={`container  ${classes['wrapper']}`}>
                <div className='row justify-content-center'>
                    <div className='col-xxl-10 col-12'>
                        <h2>FAQs</h2>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>What is the main advantage of Pharmuni courses compared to other online programs?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Pharmuni courses are developed by <strong>Zamann Pharma Support</strong>, an established industry
                                    leader actively working with major pharmaceutical companies.
                                    These courses are built from <strong>real operational experience</strong>, ensuring that the training reflects
                                    current industry practices. Upon completion, learners receive an industry-recognized certificate.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>How many courses are free, and how can I access the others?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Three courses are available for free: <strong>Introduction to GMP Annex 1, Introduction to Pharmacovigilance,</strong> and <strong>Introduction to Good Manufacturing Practices (GMP)</strong>.
                                    To access the remaining courses, learners can purchase either a monthly or an annual subscription.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>Do the courses include exercises, quizzes, or assessments, and is certification available?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Yes. At the end of each course, you will be assessed,
                                    and upon successful completion, you will receive an <strong>ISO 9001-backed certifcate</strong> issued by Zamann Pharma Support.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>In which main categories are Pharmuni courses offered? How do courses relate to Career Paths?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    Courses are grouped into relevant categories, and each collection forms a <strong>Career Path</strong>.
                                    These paths organize courses
                                    sequentially to help you progress and specialize within a specific field.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                        <Accordion className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>Is there any time limit for completing courses or passing the final quiz?</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography>
                                    There is <strong> no time limit</strong> as long as your subscription is active.
                                    You can complete courses at your own pace,
                                    and if you do not pass the final quiz on the first attempt, you can retake it.
                                </Typography>
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExploreFaq;